import React from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "../mock/blog";
import { ArrowRight, Clock, User } from "lucide-react";

export default function BlogTeaser() {
  const latest = blogPosts.slice(0, 3);
  return (
    <section id="blog" className="py-24 md:py-32 bg-[#f6f7f4]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <div className="section-eyebrow">Journal &amp; Guides</div>
            <h2 className="mt-4 font-serif-display text-[42px] md:text-[62px] leading-[1.05] text-[#0e2b2b]">
              Latest from our <span className="hero-italic">dental journal</span>
            </h2>
            <p className="mt-4 text-[15px] md:text-[16px] text-[#0e2b2b]/70 max-w-[560px]">
              Real cost guides, treatment breakdowns and patient stories from Lucknow &mdash; written by Dr. Jaspreet Singh Khurana &amp; Dr. Anshu Singh.
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Link to="/blog" className="btn-ghost">Read the Journal <ArrowRight size={16} /></Link>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {latest.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-white rounded-3xl overflow-hidden border border-[#0e2b2b]/10 card-lift block">
              <div className="aspect-[16/10] w-full overflow-hidden bg-[#eaf6f2]">
                <img src={p.cover} alt={p.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-[11px] tracking-[0.18em] uppercase text-[#14a68e] font-semibold">
                  <span>{p.category}</span>
                  <span className="w-1 h-1 rounded-full bg-[#0e2b2b]/30" />
                  <span className="flex items-center gap-1 text-[#0e2b2b]/50"><Clock size={11} /> {p.readTime}</span>
                </div>
                <h3 className="mt-3 font-serif-display text-[22px] leading-tight text-[#0e2b2b] group-hover:text-[#14a68e] transition">{p.title}</h3>
                <p className="mt-3 text-[13.5px] text-[#0e2b2b]/70 leading-relaxed line-clamp-3">{p.excerpt}</p>
                <div className="mt-5 flex items-center justify-between text-[12px] text-[#0e2b2b]/60">
                  <span className="flex items-center gap-1.5"><User size={12} /> {p.author}</span>
                  <span className="text-[#14a68e] font-semibold inline-flex items-center gap-1">Read <ArrowRight size={13} /></span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
